<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ page: number; total: number; label?: string }>();
const emit = defineEmits<{ 'update:page': [value: number] }>();
const pageCount = computed(() => Math.max(1, Math.ceil(props.total / 10)));
const start = computed(() => props.total ? (props.page - 1) * 10 + 1 : 0);
const end = computed(() => Math.min(props.page * 10, props.total));
</script>

<template>
  <nav class="paginationBar" :aria-label="label || '表格分页'">
    <span aria-live="polite">共 {{ total }} 条 · 当前 {{ start }}–{{ end }} 条 · 每页 10 条</span>
    <div class="paginationActions">
      <button type="button" class="rowAction" :disabled="page <= 1" @click="emit('update:page', 1)">首页</button>
      <button type="button" class="rowAction" :disabled="page <= 1" @click="emit('update:page', page - 1)">上一页</button>
      <span>第 {{ page }} / {{ pageCount }} 页</span>
      <button type="button" class="rowAction" :disabled="page >= pageCount" @click="emit('update:page', page + 1)">下一页</button>
      <button type="button" class="rowAction" :disabled="page >= pageCount" @click="emit('update:page', pageCount)">末页</button>
    </div>
  </nav>
</template>

<style scoped>
.paginationBar { display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 10px; padding: 12px 14px; border-top: 1px solid var(--line); color: var(--muted); font-size: 12px; }
.paginationActions { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.paginationActions > span { padding: 0 4px; color: var(--text); }
.paginationActions .rowAction { margin: 0; }
@media (max-width: 520px) { .paginationBar { font-size: 11px; } .paginationActions { gap: 4px; } }
</style>
